<template>
  <div>
    <div class="col-md-5 p-l-5 p-r-5 p-t-10">
      <div class="tabs-container">
        <ul class="nav nav-tabs">
          <li :class="{ active: currentTab === 'targets' }">
            <a
              v-t="'CAMPAIGN_STEP_ROUTING_SELECTED_TABS_TARGETS'"
              href="javascript:;"
              @click="currentTab = 'targets'"
            />
          </li>
          <li :class="{ active: currentTab === 'targetGroups' }">
            <a
              v-t="'CAMPAIGN_STEP_ROUTING_SELECTED_TABS_GROUPS'"
              href="javascript:;"
              @click="currentTab = 'targetGroups'"
            />
          </li>
          <li
            feature-flag="pingtree"
            :class="{ active: currentTab === 'pingTrees' }"
          >
            <a
              v-t="'CAMPAIGN_STEP_ROUTING_SELECTED_TABS_TREES'"
              href="javascript:;"
              @click="currentTab = 'pingTrees'"
            />
          </li>
        </ul>

        <div class="tab">
          <div
            v-show="currentTab === 'targets'"
            id="tab-1"
            class="tab-content"
          >
            <AvailableTargets
              is-rpc="vm.isRPC"
              on-update="vm.onUpdate({ routeContainer: vm.routeContainer })"
            />
          </div>

          <div
            v-show="currentTab === 'targetGroups'"
            id="tab-2"
            class="tab-content"
          >
            <!-- <available-target-groups
              is-rpc="vm.isRPC"
              on-update="vm.onUpdate({ routeContainer: vm.routeContainer })"
              route-container-type="vm.routeContainerType"
              route-container="vm.routeContainer"
              route-container-routes="vm.routeContainer.routes"
            /> -->
            <AvailableTargetGroups />
          </div>

          <div
            v-show="currentTab === 'pingTrees'"
            id="tab-3"
            feature-flag="pingtree"
            class="tab-content"
          >
            <!-- <available-ping-trees
              is-rpc="vm.isRPC"
              on-update="vm.onUpdate({ routeContainer: vm.routeContainer })"
              route-container-type="vm.routeContainerType"
              route-container="vm.routeContainer"
              route-container-routes="vm.routeContainer.routes"
            /> -->

            <AvailablePingTrees />
          </div>
        </div>
      </div>
      <!--ending of tab_container-->
      <div class="clearfix" />
    </div>

    <div class="col-md-7 p-5">
      <RoutingPlanEdit />
    </div>
    <div class="clearfix" />
  </div>
</template>

<script>

import { defineComponent, reactive } from 'vue';
import sharedMessages from '@/core/locales';
import messages from '../locales';
import { RoutingPlansViewModel } from '../models/RoutingPlansViewModel.js';
import AvailableTargets from './AvailableTargets.vue';
import AvailableTargetGroups from './AvailableTargetGroups.vue';
import AvailablePingTrees from './AvailablePingTrees.vue';
import RoutingPlanEdit from './RoutingPlanEdit.vue';

export default defineComponent({
  components: {
    AvailableTargets,
    AvailableTargetGroups,
    AvailablePingTrees,
    RoutingPlanEdit,
  },
  provide() {
    return {
      routingPlansContext: this.vm,
    };
  },
  emits: ['update'],
  props: {
    routeContainerType: {
      /** @type {PropType<'callPlan'>} */
      type: String,
      required: true
    },
    routeContainer: {
      type: Object,
      required: true
    },
    routeType: {
      type: String,
      required: true
    },
    onUpdate: {
      type: Function,
      required: false,
      default: () => () => {},
    },
  },
  data() {

    const model = new RoutingPlansViewModel(() => this.$props);
    return {
      vm: reactive(model),

      /** @type {'targets' | 'targetGroups' | 'pingTrees'} */
      currentTab: 'targets',
    };
  },
  mounted() {
    this.vm
      .withOnUpdate(routeContainer => {
        this.$emit('update', routeContainer);
      })
      .withTranslate(key => this.$t(key))
      .initialize();
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
});

</script>